import React from "react";
import { observer } from "mobx-react";
import SurveyCondensedTable from "../../../SurveyCondensedTable";
import { NumberFormat } from "../../../../Enums/constants";
import { handleHOTChangeOptions } from "../Options Table/OptionsTableHandler";

const TdBalancedTable = observer((props) => {
    return (
        <SurveyCondensedTable tableName={"TDBalancedFunds"}
            handleHOTChange={handleHOTChangeOptions}
            styleOverride={{ marginRight: '-11%', marginBottom: '0px' }}
            headers={["OptionName", "HpSusB", "HpSusS", "HpSnonus", "HpSemerg", "HpFbond", "HpFtip", "HpFstable", "HpFcash",
                "HpFother", "HpRcommod", "HpRreit", "HpRre", "HpP", "HpOriskpar", "HpOother", "TotalPercent"]}
            columns={[
                { data: 'OptionName', readOnly: true },
                { data: 'HpSusB', className: "htRight" },
                { data: 'HpSusS', className: "htRight" },
                { data: 'HpSnonus', className: "htRight" },
                { data: 'HpSemerg', className: "htRight" },
                { data: 'HpFbond', className: "htRight" },
                { data: 'HpFtip', className: "htLeft" },
                { data: 'HpFstable', className: "htRight" },
                { data: 'HpFcash', className: "htRight" },
                { data: 'HpFother', className: "htRight" },
                { data: 'HpRcommod', className: "htRight" },
                { data: 'HpRreit', className: "htCenter" },
                { data: 'HpRre', className: "htRight" },
                { data: 'HpP', className: "htRight" },
                { data: 'HpOriskpar', className: "htLeft" },
                { data: 'HpOother', className: "htRight" },
                { data: 'TotalPercent', readOnly: true },
            ]}
            formatting={['', NumberFormat.PERCENTAGE, NumberFormat.PERCENTAGE, NumberFormat.PERCENTAGE, NumberFormat.PERCENTAGE, NumberFormat.PERCENTAGE,
                NumberFormat.PERCENTAGE, NumberFormat.PERCENTAGE, NumberFormat.PERCENTAGE, NumberFormat.PERCENTAGE, NumberFormat.PERCENTAGE,
                NumberFormat.PERCENTAGE, NumberFormat.PERCENTAGE, NumberFormat.PERCENTAGE, NumberFormat.PERCENTAGE, NumberFormat.PERCENTAGE, NumberFormat.PERCENTAGE]}
            colWidths={['200px', '80px', '80px', '80px', '80px', '80px', '80px', '80px', '80px', '80px', '80px', '80px', '80px', '80px', '80px', '80px', '80px']}
            calculationsProvided={[{
                calColName: "TotalPercent", sums: ["HpSusB", "HpSusS", "HpSnonus", "HpSemerg", "HpFbond", "HpFtip", "HpFstable", "HpFcash",
                    "HpFother", "HpRcommod", "HpRreit", "HpRre", "HpP", "HpOriskpar", "HpOother"]
            }]}
            hiddenColumns={[]}

            nestedHeaders={[
                [{ label: ' ', colspan: 1 }, { label: 'Stocks', colspan: 4 }, { label: 'Fixed Income', colspan: 5 }, { label: 'Alternative Assets', colspan: 5 }, { label: 'Other', colspan: 1 }, { label: ' ', colspan: 1 }],
                ['Option name', 'U.S. <br/> Broad <br/>or large<br/>cap', 'U.S. <br/> Mid <br/>or small<br/>cap', 'Non-<br/>U.S.', 'Emerging', 'Core<br/>bonds', 'TIPS',
                    'Stable<br/>value', 'Cash', 'Other<br/>Fixed<br/>income', 'Commo-<br/>dities', 'REITs', 'Real<br/>estate', 'Private</br>equity', 'Risk<br/>Parity', 'All<br/>other<br/>assets', 'Total']
            ]}
        />
    );

});
export default TdBalancedTable;

